// Stryker disable all

import { sendExperienceAnalytics } from '@atlassian/jira-issue-view-analytics/src/index.tsx';
import HttpError, { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';

const isGiraUrl = (url: string): boolean => url.startsWith('/rest/gira/1/');

export const performIssueRequest = async <T,>(
	requestFn: (url: string, options: RequestInit) => Promise<T>,
	url: string,
	options: RequestInit = {},
	path = 'unknown',
): Promise<T> => {
	const defaultExperienceDescription = {
		experience: isGiraUrl(url) ? 'issueGira' : 'issueRest',
		analyticsSource: isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
		application: null,
		edition: null,
	};

	try {
		const response = await requestFn(url, options);

		return response;
	} catch (error) {
		let traceId;
		let statusCode;
		let errorMessage;

		if (
			error instanceof Error ||
			error instanceof HttpError ||
			error instanceof ValidationError ||
			error instanceof TypeError
		) {
			errorMessage = error.message;
		}

		if (error instanceof HttpError || error instanceof ValidationError) {
			traceId = error.traceId;
			statusCode = error.statusCode;
		}

		const additionalAttributes = {
			statusCode: statusCode || 0,
			errorMessage: errorMessage || 'unknown',
			traceId: traceId || 'unknown',
			path,
		};

		if (
			(statusCode && statusCode >= 400 && statusCode < 500) ||
			(error instanceof Error && error.cause instanceof TypeError)
		) {
			sendExperienceAnalytics({
				...defaultExperienceDescription,
				action: 'taskAbort',
				additionalAttributes,
			});

			throw error;
		}

		sendExperienceAnalytics({
			...defaultExperienceDescription,
			action: 'taskFail',
			additionalAttributes,
		});

		throw error;
	}
};
